import style from "./mainBranding.module.scss";
import kakaotalkIcon from "../../../assets/images/sub/purchase_voucher/kakaotalk_icon.svg";
import kpassIcon from "../../../assets/images/main/brandsection/kpass_simple_logo.png";
import {useEffect, useState} from "react";
import {useLanguage, useUserAgent} from "../../../hooks/hooks";

// 이미지 import
import backgroundDesktop from "../../../assets/images/main/brandsection/mainbackground.png";
import backgroundTablet from "../../../assets/images/main/brandsection/mainbackground_ta.png";
import backgroundMobile from "../../../assets/images/main/brandsection/mainbackground_mo.png";

// 압축 이미지 import
import compressedDesktop from "../../../assets/images/main/brandsection/mainbackground_compressed.png";
import compressedTablet from "../../../assets/images/main/brandsection/mainbackground_compressed_ta.png";
import compressedMobile from "../../../assets/images/main/brandsection/mainbackground_compressed_mo.png";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";


export function BrandSection() {
    const { t } = useTranslation("brand");
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const {isDesktop, isTablet} = useUserAgent();
    const {isKorean} = useLanguage();
    const highQualityImage = isDesktop ? backgroundDesktop : isTablet ? backgroundTablet : backgroundMobile;
    const lowQualityImage = isDesktop ? compressedDesktop : isTablet ? compressedTablet : compressedMobile;

    useEffect(() => {
        const img = new Image();
        img.src = highQualityImage;
        img.onload = () => setIsLoaded(true);
    }, [highQualityImage]);

    const onClickDetail = () => {
        navigate('/purchase-voucher');
    }

    return (
        <div className={style.brandingArea}>
            <div
                className={style.imageArea}
                style={{backgroundImage: `url(${isLoaded ? highQualityImage : lowQualityImage})`}}
            >
                <div className={`${style.description} ${isKorean ? "" : style.en}`}/>
                <div className={style.kids}/>
            </div>

            <div className={style.buttonArea}>
                <button className={style.kpassBtn}
                        onClick={onClickDetail}>
                    <img className={style.icon} src={kpassIcon} alt={"케이패스 아이콘"}/>
                    <span className={style.text}>{t('btn.detail')}</span>
                </button>
                {isKorean && (
                    <button className={style.kakaoBtn}
                            onClick={() => window.open("https://pf.kakao.com/_txlSZxj/chat", "_blank")}>
                        <img className={style.icon} src={kakaotalkIcon} alt={"카카오톡 아이콘"}/>
                        <span className={style.text}>카카오톡 1:1 문의</span>
                    </button>
                )}
            </div>
        </div>
    )
}